/* RIVAL dynamic size discount badges
   Size badges reflect the currently selected colour.
   Colour badges stay static (any-match) and are rendered in Liquid. */
(function () {
  function pct(compare, price) {
    if (!compare || compare <= price) return 0;
    return Math.round(((compare - price) * 100) / compare);
  }

  function optIndex(fieldset) {
    var di = fieldset.getAttribute('data-index') || '';
    var n = parseInt(di.replace('option', ''), 10);
    return isNaN(n) ? null : n - 1;
  }

  function updateSection(section) {
    var dataEl = section.querySelector('[data-rival-variants]');
    var sizeFs = section.querySelector('[data-rival-size]');
    if (!dataEl || !sizeFs) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var sizeIdx = optIndex(sizeFs);
    if (sizeIdx === null) return;

    var colorFs = section.querySelector('[data-rival-color]');
    var colorIdx = colorFs ? optIndex(colorFs) : null;
    var selectedColor = null;
    if (colorFs) {
      var checked = colorFs.querySelector('input[data-variant-input]:checked');
      selectedColor = checked ? checked.value : null;
    }

    // clear old size badges
    var old = sizeFs.querySelectorAll('.variant-discount-badge');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    var wraps = sizeFs.querySelectorAll('.variant-input');
    for (var w = 0; w < wraps.length; w++) {
      var wrap = wraps[w];
      var sizeVal = wrap.getAttribute('data-value');
      var best = 0;
      for (var v = 0; v < variants.length; v++) {
        var vo = variants[v].o;
        if (vo[sizeIdx] !== sizeVal) continue;
        if (colorIdx !== null && selectedColor !== null && vo[colorIdx] !== selectedColor) continue;
        var p = pct(variants[v].c, variants[v].p);
        if (p > best) best = p;
      }
      if (best > 0) {
        var span = document.createElement('span');
        span.className = 'variant-discount-badge';
        span.textContent = '-' + best + '%';
        wrap.appendChild(span);
      }
    }
  }

  function updateAll() {
    var sections = document.querySelectorAll('[data-section-type="product-template"], .product-section');
    for (var i = 0; i < sections.length; i++) updateSection(sections[i]);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-variant-input]')) updateAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
  window.addEventListener('load', updateAll);
})();
